import React, { useContext, useEffect, useState } from "react";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import {
  Box,
  Fab,
  FormControl,
  Grid,
  InputLabel,
  makeStyles,
  MenuItem,
  Select,
  Tooltip,
  Button,
  Chip,
  TextField,
  InputAdornment,
  IconButton,
} from "@material-ui/core/";
import TableFooter from "@material-ui/core/TableFooter";
import TablePagination from "@material-ui/core/TablePagination";
import DnerhsApi, { CancelToken } from "../../api/DnerhsApi";
import { Link } from "react-router-dom";
import VisibilityIcon from "@material-ui/icons/Visibility";
import EditIcon from "@material-ui/icons/Edit";
import AddIcon from "@material-ui/icons/Add";
import SearchIcon from "@material-ui/icons/Search";
import ClearIcon from "@material-ui/icons/Clear";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import Menu from "@material-ui/core/Menu";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import UserContext from "../../context/User/UserContext";
import history from "../../utils/History";
import { getSedeSeleccionada } from "services/UsuarioService";
import Roles from "constants/Roles";
import moment from "moment";
import { trackPromise } from "react-promise-tracker";
import Alert from "../../components/Alert";
import EditarVigenciaModal from "./FormDialog/EditarVigenciaModal";

const useStyles = makeStyles((theme) => ({
  // Contenedor principal
  mainContainer: {
    backgroundColor: '#f8f9fa',
    minHeight: '100vh',
    padding: theme.spacing(1),
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(2),
    },
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(3),
    },
  },

  // Card principal
  mainCard: {
    borderRadius: 8,
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
    overflow: 'hidden',
    background: '#ffffff',
    border: '1px solid #e9ecef',
  },

  title: {
    marginBottom: theme.spacing(3),
    color: theme.palette.primary.main,
    fontWeight: 'bold',
  },

  // Sección de filtros
  filtersSection: {
    background: '#f5f5f5',
    padding: theme.spacing(3),
    marginBottom: theme.spacing(3),
    borderBottom: '1px solid #dee2e6',
  },

  // Campo de búsqueda mejorado
  searchField: {
    '& .MuiOutlinedInput-root': {
      borderRadius: 4,
      backgroundColor: 'white',
      border: '1px solid #ced4da',
      '&:hover': {
        borderColor: '#495057',
      },
      '&.Mui-focused': {
        borderColor: '#007bff',
        boxShadow: '0 0 0 0.2rem rgba(0,123,255,0.25)',
      },
    },
    '& .MuiInputLabel-outlined': {
      fontWeight: 500,
      color: '#495057',
    },
  },

  // Select de filtros
  formControl: {
    '& .MuiOutlinedInput-root': {
      borderRadius: 4,
      backgroundColor: 'white',
      border: '1px solid #ced4da',
      '&:hover': {
        borderColor: '#495057',
      },
      '&.Mui-focused': {
        borderColor: '#007bff',
        boxShadow: '0 0 0 0.2rem rgba(0,123,255,0.25)',
      },
    },
    '& .MuiInputLabel-outlined': {
      color: '#495057',
    },
  },

  // Contador de resultados
  resultsCounter: {
    background: '#007bff',
    color: 'white',
    padding: '6px 12px',
    borderRadius: 4,
    fontSize: '0.875rem',
    fontWeight: 500,
    display: 'inline-block',
    marginTop: theme.spacing(1),
  },

  // Tabla mejorada
  tableSection: {
    padding: theme.spacing(2),
  },

  table: {
    '& .MuiTableHead-root': {
      backgroundColor: '#f8f9fa',
    },
    '& .MuiTableCell-head': {
      fontWeight: 600,
      fontSize: '0.875rem',
      color: '#495057',
      borderBottom: '2px solid #dee2e6',
      backgroundColor: '#f8f9fa',
      padding: theme.spacing(1),
      [theme.breakpoints.up('md')]: {
        padding: theme.spacing(1.5),
      },
    },
    '& .MuiTableRow-root': {
      '&:hover': {
        backgroundColor: '#f8f9fa',
        transition: 'background-color 0.2s ease',
      },
      '&:nth-child(even)': {
        backgroundColor: '#fdfdfd',
      },
    },
    '& .MuiTableCell-body': {
      borderBottom: '1px solid #dee2e6',
      padding: theme.spacing(1),
      fontSize: '0.8rem',
      [theme.breakpoints.up('md')]: {
        padding: theme.spacing(1.5),
        fontSize: '0.875rem',
      },
    },
    // Responsive table
    [theme.breakpoints.down("md")]: {
      '& .MuiTableCell-head, & .MuiTableCell-body': {
        padding: theme.spacing(0.5),
        fontSize: '0.75rem',
      },
    },
    [theme.breakpoints.down("sm")]: {
      overflowX: "auto",
      display: "block",
      '& .MuiTableCell-head, & .MuiTableCell-body': {
        padding: theme.spacing(0.5),
        fontSize: '0.7rem',
        minWidth: '80px',
      },
    },
  },

  // Botón de acción mejorado
  actionButton: {
    backgroundColor: '#007bff',
    color: 'white',
    '&:hover': {
      backgroundColor: '#0056b3',
      transform: 'translateY(-1px)',
      boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
    },
    transition: 'all 0.2s ease',
  },

  // Botón de menú de tres puntos
  menuButton: {
    color: '#495057',
    padding: '8px',
    '&:hover': {
      backgroundColor: 'rgba(0,0,0,0.04)',
      color: '#007bff',
    },
    transition: 'all 0.2s ease',
  },

  // Chips mejorados
  chipRenovacion: {
    fontWeight: 500,
    fontSize: '0.75rem',
  },

  // ID Convenio destacado
  convenioId: {
    backgroundColor: '#495057',
    color: 'white',
    padding: '4px 8px',
    borderRadius: 4,
    fontWeight: 600,
    fontSize: '0.8rem',
    display: 'inline-block',
  },

  button: {
    margin: theme.spacing(),
  },
}));

const List = () => {
  const classes = useStyles();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalElements, setTotalElements] = useState(0); // Cambiar a 0 para mejor control
  const [rows, setRows] = useState([]);
  const [filteredRows, setFilteredRows] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [open, setOpen] = React.useState(false);
  const { userData, hasRole } = useContext(UserContext);
  const [status, setStatus] = useState("");
  const [filtroRenovacion, setFiltroRenovacion] = useState(""); // Filtro de renovación
  const [openRenovacion, setOpenRenovacion] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [selectedConvenio, setSelectedConvenio] = useState(null);
  const [renovacionesConvenios, setRenovacionesConvenios] = useState({});
  const [cronogramasPendientes, setCronogramasPendientes] = useState({});
  const [expandedConvenios, setExpandedConvenios] = useState({});
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const periodosVisiblesSolicitados = React.useRef(new Set());

  useEffect(() => {
    loadData({ page, rowsPerPage });
    loadCronogramasPendientes();
  }, [page, rowsPerPage, status]); // Asegúrate de agregar estas dependencias

  // Función para filtrar los datos basado en el término de búsqueda y filtros
  useEffect(() => {
    let filtered = rows;

    // Filtrar por término de búsqueda
    if (searchTerm.trim()) {
      filtered = filtered.filter((row) => {
        const searchLower = searchTerm.toLowerCase();

        // Determinar si está vencido
        const hoy = moment();
        const fechaVencimiento = row.fechaFinVigencia ? moment(row.fechaFinVigencia) : null;
        const estaVencido = fechaVencimiento && fechaVencimiento.isBefore(hoy, 'day');
        const proximoAVencer = fechaVencimiento && fechaVencimiento.diff(hoy, 'days') <= 30 && fechaVencimiento.diff(hoy, 'days') > 0;
        const renovacionTexto = getRenovacionItems(row)
          .map((item) => `renovado ${item.numero || ''} ${item.labelEstado || ''} renovacion`)
          .join(" ")
          .toLowerCase();

        return (
          // ID Convenio
          (row.id && row.id.toString().toLowerCase().includes(searchLower)) ||
          // Fecha Fin Vigencia
          (row.fechaFinVigencia && moment(row.fechaFinVigencia).format("DD/MM/YYYY").toLowerCase().includes(searchLower)) ||
          // Institución Formadora
          (row.institucionFormadora?.institucion && row.institucionFormadora.institucion.toLowerCase().includes(searchLower)) ||
          // Sede
          (row.institucionFormadora?.sede && row.institucionFormadora.sede.toLowerCase().includes(searchLower)) ||
          // Categoría
          (row.categoria && row.categoria.toLowerCase().includes(searchLower)) ||
          // Número de Resolución
          (row.numeroResolucion && row.numeroResolucion.toLowerCase().includes(searchLower)) ||
          // Estado
          (row.estado && row.estado.toLowerCase().includes(searchLower)) ||
          // Renovacion
          (renovacionTexto && renovacionTexto.includes(searchLower)) ||
          // Vencido - buscar por "vencido", "vencidos"
          (estaVencido && (
            searchLower.includes('vencido') ||
            searchLower.includes('vencidos')
          )) ||
          // Próximo a vencer - buscar por "proximo", "próximo", "por vencer"
          (proximoAVencer && (
            searchLower.includes('proximo') ||
            searchLower.includes('próximo') ||
            searchLower.includes('por vencer') ||
            searchLower.includes('vence pronto')
          ))
        );
      });
    }

    // Filtrar por renovación
    if (filtroRenovacion === "renovacion") {
      filtered = filtered.filter((row) => row.renovacion === true || getRenovacionItems(row).length > 0);
    } else if (filtroRenovacion === "renovacion_pendiente") {
      filtered = filtered.filter((row) => hasRenovacionPendiente(row));
    } else if (filtroRenovacion === "no_renovacion") {
      filtered = filtered.filter((row) => !row.renovacion && getRenovacionItems(row).length === 0);
    }

    setFilteredRows(filtered);
  }, [rows, searchTerm, filtroRenovacion, renovacionesConvenios]);

  // Resetear página cuando cambie la búsqueda
  useEffect(() => {
    setPage(0);
  }, [searchTerm, status]);

  // Función para obtener los datos paginados
  const getPaginatedData = () => {
    const startIndex = page * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;
    return filteredRows.slice(startIndex, endIndex);
  };

  useEffect(() => {
    loadPeriodosConveniosVisibles(getPaginatedData());
  }, [filteredRows, page, rowsPerPage]);

  const getEstadoRenovacionLabel = (estado) => {
    const estados = {
      SOLICITADA: "Solicitada",
      EN_GESTION_ACADEMICA: "Gestion autorizada",
      APROBADA: "Aprobada",
      RECHAZADA: "Rechazada",
    };
    return estados[estado] || estado || "Sin estado";
  };

  const getEstadoRenovacionColor = (estado) => {
    if (estado === "APROBADA") {
      return { backgroundColor: '#e8f5e9', color: '#2e7d32' };
    }
    if (estado === "RECHAZADA") {
      return { backgroundColor: '#ffebee', color: '#c62828' };
    }
    if (estado === "EN_GESTION_ACADEMICA") {
      return { backgroundColor: '#e3f2fd', color: '#1565c0' };
    }
    return { backgroundColor: '#fff8e1', color: '#8a6d00' };
  };

  const getNumeroRenovacionLegacy = (row) => {
    const match = row.tipoRenovacion ? String(row.tipoRenovacion).match(/\d+/) : null;
    if (match) {
      return Number(match[0]);
    }
    if (row.fechaRenovado3) {
      return 3;
    }
    if (row.fechaRenovado2) {
      return 2;
    }
    if (row.fechaRenovado1 || row.renovacion === true) {
      return 1;
    }
    return null;
  };

  const isPeriodoRenovacion = (periodo) =>
    periodo.tipoPeriodo === "RENOVACION" || periodo.tipoPeriodo === "RENOVACION_LEGACY";

  const isEstadoRenovacionPendiente = (estado) =>
    estado === "SOLICITADA" || estado === "EN_GESTION_ACADEMICA";

  const getNumeroRenovacionPeriodo = (periodo, renovaciones) => {
    if (periodo.numeroPeriodo) {
      return periodo.numeroPeriodo;
    }
    return null;
  };

  const getRenovacionesPeriodo = (row) => {
    const periodos = row.periodosConvenio || renovacionesConvenios[row.id] || [];
    return periodos
      .filter(isPeriodoRenovacion)
      .sort((a, b) => (a.id || 0) - (b.id || 0));
  };

  const getRenovacionItems = (row) => {
    const renovaciones = getRenovacionesPeriodo(row);

    if (renovaciones.length > 0) {
      return renovaciones
        .map((periodo) => ({
          id: periodo.id,
          numero: getNumeroRenovacionPeriodo(periodo, renovaciones),
          estado: periodo.estado,
          labelEstado: getEstadoRenovacionLabel(periodo.estado),
          activo: periodo.activo,
          tipoPeriodo: periodo.tipoPeriodo,
        }))
        .sort((a, b) => {
          const numeroA = a.numero || 99;
          const numeroB = b.numero || 99;
          if (numeroA !== numeroB) {
            return numeroA - numeroB;
          }
          return (a.id || 0) - (b.id || 0);
        });
    }

    if (row.renovacion === true) {
      return [{
        id: `legacy-${row.id}`,
        numero: getNumeroRenovacionLegacy(row),
        estado: "APROBADA",
        labelEstado: "Aprobada",
        activo: true,
        tipoPeriodo: "RENOVACION_LEGACY",
      }];
    }

    return [];
  };

  const hasRenovacionPendiente = (row) =>
    getRenovacionItems(row).some((item) =>
      item.activo !== false && isEstadoRenovacionPendiente(item.estado)
    );

  const getRenovacionInfo = (row) => {
    const items = getRenovacionItems(row);
    if (items.length === 0) {
      return null;
    }
    const pendientes = items.filter((item) => isEstadoRenovacionPendiente(item.estado));
    return pendientes.length > 0 ? pendientes[pendientes.length - 1] : items[items.length - 1];
  };

  const getRenovacionChipLabel = (item) => {
    if (item.estado === "RECHAZADA") {
      return "Rechazada";
    }
    return `${item.numero ? `Renovado ${item.numero}` : 'Pendiente'} - ${item.labelEstado}`;
  };

  const actualizarRowsConPeriodos = (periodosMap) => {
    if (!periodosMap || Object.keys(periodosMap).length === 0) {
      return;
    }

    setRenovacionesConvenios((prev) => ({
      ...prev,
      ...periodosMap,
    }));
    setRows((prevRows) =>
      prevRows.map((row) =>
        periodosMap[row.id]
          ? { ...row, periodosConvenio: periodosMap[row.id] }
          : row
      )
    );
  };

  const loadPeriodosConveniosVisibles = async (filas) => {
    const filasPendientes = (filas || []).filter((row) => {
      if (!row || !row.id || periodosVisiblesSolicitados.current.has(row.id)) {
        return false;
      }

      const tienePeriodosEnFila = Array.isArray(row.periodosConvenio) && row.periodosConvenio.length > 0;
      const tienePeriodosEnMapa = Array.isArray(renovacionesConvenios[row.id]) && renovacionesConvenios[row.id].length > 0;
      return !tienePeriodosEnFila && !tienePeriodosEnMapa;
    });

    if (filasPendientes.length === 0) {
      return;
    }

    const map = {};
    for (const row of filasPendientes) {
      periodosVisiblesSolicitados.current.add(row.id);
      try {
        const { data } = await DnerhsApi.get(`/convenios/${row.id}/periodos`);
        map[row.id] = Array.isArray(data) ? data : [];
      } catch (error) {
        console.log(`Error al cargar periodos visibles del convenio ${row.id}:`, error);
      }
    }

    actualizarRowsConPeriodos(map);
  };

  const loadRenovacionesConvenios = async (convenios) => {
    const convenioIds = (convenios || [])
      .map((convenio) => convenio.id)
      .filter((id) => id !== null && id !== undefined);

    if (convenioIds.length === 0) {
      setRenovacionesConvenios({});
      return {};
    }

    try {
      const { data } = await DnerhsApi.get("/convenios/periodos-por-convenio", {
        params: { convenioIds: convenioIds.join(",") },
      });
      const map = data || {};
      setRenovacionesConvenios(map);
      return map;
    } catch (error) {
      console.log("Error al cargar periodos agrupados de convenios:", error);
      setRenovacionesConvenios({});
      return {};
    }
  };

  const loadData = async ({ page = 0, rowsPerPage = 10 }) => {
    const source = CancelToken.source();

    try {
      let url;
      if (hasRole(Roles.ROLE_DNERHS)) {
        url = status === "" ? `/convenios` : `/convenios/estado=${status}`;
      } else {
        const datosInstitucion = getSedeSeleccionada();
        url =
          status === ""
            ? `/instituciones/formadoras/${datosInstitucion?.formadora?.id}/convenios`
            : `/instituciones/formadoras/${datosInstitucion?.formadora?.id}/convenios/estado=${status}`;
      }
      const response = await DnerhsApi.get(url, {
        cancelToken: source.token,
      });
      const rowsBase = Array.isArray(response.data) ? response.data : [];
      setRows(rowsBase);
      setFilteredRows(rowsBase); // Mostrar convenios aunque falle la carga de renovaciones.
      setTotalElements(rowsBase.length);
      setRenovacionesConvenios({});
      loadRenovacionesConvenios(rowsBase).then((periodosMap) => {
        const rowsConPeriodos = rowsBase.map((convenio) => ({
          ...convenio,
          periodosConvenio: periodosMap[convenio.id] || [],
        }));
        setRows(rowsConPeriodos);
        setFilteredRows(rowsConPeriodos);
      });
    } catch (error) {
      console.log("Error al cargar convenios:", error);
      if (error.message === "Network Error") {
        console.log("❌ Backend no está funcionando. Inicie el servidor backend.");
      }
      // Mostrar datos de ejemplo si no hay conexión
      setRows([]);
      setFilteredRows([]);
      setTotalElements(0);
    }
  };

  const loadCronogramasPendientes = async () => {
    try {
      const response = await DnerhsApi.get('/convenios/cronogramas-pendientes');
      setCronogramasPendientes(response.data);
      console.log("? Cronogramas pendientes cargados:", response.data);
    } catch (error) {
      console.log("Error al cargar cronogramas pendientes:", error);
      setCronogramasPendientes({});
    }
  };

  const toggleExpandConvenio = (convenioId) => {
    setExpandedConvenios(prev => ({
      ...prev,
      [convenioId]: !prev[convenioId]
    }));
  };

  const handleMenuOpen = (event, row) => {
    setAnchorEl(event.currentTarget);
    setSelectedRow(row);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedRow(null);
  };

  const handleVerDetalles = () => {
    if (selectedRow) {
      history.push(`/convenios/editar/${selectedRow.id}`);
    }
    handleMenuClose();
  };

  const handleEditarVigencia = () => {
    if (selectedRow) {
      handleOpenEditModal(selectedRow);
    }
    handleMenuClose();
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0); // Reiniciar a la primera página al cambiar el número de filas
  };

  const handleChange = (event) => {
    setStatus(event.target.value);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleChangeRenovacion = (event) => {
    setFiltroRenovacion(event.target.value);
  };

  const handleCloseRenovacion = () => {
    setOpenRenovacion(false);
  };

  const handleOpenRenovacion = () => {
    setOpenRenovacion(true);
  };

  const handleOpenEditModal = (convenio) => {
    setSelectedConvenio(convenio);
    setEditModalOpen(true);
  };

  const handleCloseEditModal = () => {
    setEditModalOpen(false);
    setSelectedConvenio(null);
  };

  const handleSaveEdit = async (data) => {
    try {
      // Agregar motivoModificacion si no existe
      const payload = {
        ...data,
        motivoModificacion: data.observacion || "Actualización de vigencia"
      };

      const url = `/convenios/${selectedConvenio.id}/actualizar-vigencia`;
      const response = await trackPromise(
        DnerhsApi.put(url, null, { params: payload })
      );

      if (response.data.success) {
        Alert.show({
          message: "Convenio actualizado exitosamente",
          type: "success",
        });

        // Recargar datos
        loadData({ page, rowsPerPage, status });
        handleCloseEditModal();
      } else {
        Alert.show({
          message: response.data.message || "Error al actualizar convenio",
          type: "error",
        });
      }
    } catch (error) {
      console.error("Error al actualizar convenio:", error);
      Alert.show({
        message: "Error al actualizar convenio: " + (error.response?.data?.message || error.message),
        type: "error",
      });
    }
  };

  // Agregar estilos de animación para convenios vencidos
  React.useEffect(() => {
    const style = document.createElement('style');
    style.innerHTML = `
      @keyframes pulse {
        0%, 100% {
          opacity: 1;
        }
        50% {
          opacity: 0.7;
        }
      }
    `;
    document.head.appendChild(style);
    return () => {
      document.head.removeChild(style);
    };
  }, []);

  return (
    <div className={classes.mainContainer}>
      <Grid container justifyContent="center">
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <Paper className={classes.mainCard}>
            {/* Header Section */}
            <Box display="flex" alignItems="center" justifyContent="space-between">
              <Typography variant="h4" className={classes.title}>
                Gestión de Convenios
              </Typography>
            </Box>

            {/* Sección de Filtros */}
            <div className={classes.filtersSection}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    label="Buscar convenios"
                    placeholder="Buscar por ID, fecha, institución, sede, categoría, resolución, estado. Escriba 'vencido' o 'próximo a vencer' para filtrar..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className={classes.searchField}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon style={{ color: '#6c757d' }} />
                        </InputAdornment>
                      ),
                      endAdornment: searchTerm && (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={() => setSearchTerm('')}
                            edge="end"
                            size="small"
                            style={{ color: '#6c757d' }}
                          >
                            <ClearIcon />
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                  {searchTerm && (
                    <div className={classes.resultsCounter}>
                      {filteredRows.length} de {rows.length} convenios encontrados
                    </div>
                  )}
                </Grid>

                <Grid item xs={12} sm={6} md={3} lg={3}>
                  <FormControl fullWidth variant="outlined" className={classes.formControl}>
                    <InputLabel id="status-filter-label">
                      Filtrar por Estado
                    </InputLabel>
                    <Select
                      labelId="status-filter-label"
                      id="status-filter-select"
                      label="Filtrar por Estado"
                      open={open}
                      onClose={handleClose}
                      onOpen={handleOpen}
                      value={status}
                      onChange={handleChange}
                    >
                      <MenuItem value="">
                        <em>Todos los estados</em>
                      </MenuItem>
                      <MenuItem value={"Convenio en proceso de creación por el responsable"}>
                        En proceso de creación
                      </MenuItem>
                      <MenuItem value={"Convenio pendiente de revisión por DNERHS"}>
                        Pendiente de revisión
                      </MenuItem>
                      <MenuItem value={"Convenio con correcciones solicitadas por DNERHS"}>
                        Con correcciones solicitadas
                      </MenuItem>
                      <MenuItem value={"Convenio pendiente de firma"}>
                        Pendiente de firma
                      </MenuItem>
                      <MenuItem value={"Convenio firmado"}>
                        Firmado
                      </MenuItem>
                      <MenuItem value={"Convenio anulado"}>
                        Anulado
                      </MenuItem>
                      <MenuItem value={"Convenio archivado"}>
                        Archivado
                      </MenuItem>
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={6} md={3} lg={3}>
                  <FormControl fullWidth variant="outlined" className={classes.formControl}>
                    <InputLabel id="renovacion-filter-label">
                      Filtrar por Renovación
                    </InputLabel>
                    <Select
                      labelId="renovacion-filter-label"
                      id="renovacion-filter-select"
                      label="Filtrar por Renovación"
                      open={openRenovacion}
                      onClose={handleCloseRenovacion}
                      onOpen={handleOpenRenovacion}
                      value={filtroRenovacion}
                      onChange={handleChangeRenovacion}
                    >
                      <MenuItem value="">
                        <em>Todos</em>
                      </MenuItem>
                      <MenuItem value="renovacion">
                        Renovación
                      </MenuItem>
                      <MenuItem value="renovacion_pendiente">
                        Renovaciones pendientes
                      </MenuItem>
                      <MenuItem value="no_renovacion">
                        No Renovación
                      </MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </div>

            {/* Sección de Tabla */}
            <div className={classes.tableSection}>
              <div style={{ overflowX: 'auto' }}>
                <Table className={classes.table}>
                <TableHead>
                  <TableRow>
                    <TableCell align="center">
                      <strong>Acción</strong>
                    </TableCell>
                    <TableCell align="center">
                      <strong>ID Convenio</strong>
                    </TableCell>
                    <TableCell align="left">
                      <strong>Fecha Fin Vigencia</strong>
                    </TableCell>
                    <TableCell align="left">
                      <strong>Institución Formadora</strong>
                    </TableCell>
                    <TableCell align="left">
                      <strong>Sede</strong>
                    </TableCell>
                    <TableCell align="left">
                      <strong>Categoría</strong>
                    </TableCell>
                    <TableCell align="center">
                      <strong>Número de Resolución</strong>
                    </TableCell>
                    <TableCell align="center">
                      <strong>Renovación</strong>
                    </TableCell>
                    <TableCell align="left">
                      <strong>Estado</strong>
                    </TableCell>
                    <TableCell align="left">
                      <strong>Cronogramas Pendientes</strong>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {getPaginatedData().map((row, index) => {
                    // Verificar si el convenio está vencido
                    const hoy = moment();
                    const fechaVencimiento = row.fechaFinVigencia ? moment(row.fechaFinVigencia) : null;
                    const estaVencido = fechaVencimiento && fechaVencimiento.isBefore(hoy, 'day');
                    const proximoAVencer = fechaVencimiento && fechaVencimiento.diff(hoy, 'days') <= 30 && fechaVencimiento.diff(hoy, 'days') > 0;
                    const renovacionItems = getRenovacionItems(row);

                    return (
                    <TableRow
                      key={index}
                      style={{
                        backgroundColor: estaVencido ? '#ffebee' : (proximoAVencer ? '#fff3e0' : 'transparent'),
                        transition: 'background-color 0.3s ease'
                      }}
                    >
                      <TableCell align="center">
                        <Tooltip title="Acciones" arrow>
                          <IconButton
                            className={classes.menuButton}
                            onClick={(event) => handleMenuOpen(event, row)}
                            size="small"
                          >
                            <MoreVertIcon />
                          </IconButton>
                        </Tooltip>
                      </TableCell>

                      {/* ID Convenio */}
                      <TableCell align="center">
                        <div className={classes.convenioId}>
                          #{row.id || 'N/A'}
                        </div>
                      </TableCell>

                      {/* Fecha Fin Vigencia */}
                      <TableCell align="left">
                        {row.fechaFinVigencia ? (
                          <Box display="flex" flexDirection="column" gap={0.5}>
                            <Typography
                              variant="body2"
                              style={{
                                fontWeight: estaVencido ? 700 : 500,
                                color: estaVencido ? '#c62828' : (proximoAVencer ? '#e65100' : '#212529')
                              }}
                            >
                              {moment(row.fechaFinVigencia).format("DD/MM/YYYY")}
                            </Typography>
                            {estaVencido && (
                              <Chip
                                label="VENCIDO"
                                size="small"
                                style={{
                                  backgroundColor: '#c62828',
                                  color: 'white',
                                  fontWeight: 700,
                                  fontSize: '0.65rem',
                                  height: '20px',
                                  animation: 'pulse 2s infinite',
                                  width: 'fit-content'
                                }}
                              />
                            )}
                            {proximoAVencer && (
                              <Chip
                                label={`Vence en ${fechaVencimiento.diff(hoy, 'days')} días`}
                                size="small"
                                style={{
                                  backgroundColor: '#ff9800',
                                  color: 'white',
                                  fontWeight: 600,
                                  fontSize: '0.65rem',
                                  height: '20px',
                                  width: 'fit-content'
                                }}
                              />
                            )}
                          </Box>
                        ) : (
                          <Typography variant="caption" color="textSecondary" style={{ fontStyle: 'italic' }}>
                            Pendiente
                          </Typography>
                        )}
                      </TableCell>

                      <TableCell align="left">{row.institucionFormadora.institucion}</TableCell>
                      <TableCell align="left">{row.institucionFormadora.sede}</TableCell>
                      <TableCell align="left">{row.categoria}</TableCell>

                      {/* Número de Resolución */}
                      <TableCell align="center">
                        {row.numeroResolucion && row.numeroResolucion.trim() !== '' ? (
                          <Chip
                            label={row.numeroResolucion}
                            size="small"
                            style={{
                              backgroundColor: '#e3f2fd',
                              color: '#1976d2',
                              fontWeight: 600,
                              fontSize: '0.75rem'
                            }}
                          />
                        ) : (
                          <Typography variant="caption" color="textSecondary" style={{
                            fontStyle: 'italic',
                            fontSize: '0.75rem'
                          }}>
                            Pendiente
                          </Typography>
                        )}
                      </TableCell>

                      {/* Renovación */}
                      <TableCell align="center">
                        {renovacionItems.length > 0 ? (
                          <Box display="flex" flexDirection="column" alignItems="center" style={{ gap: 4 }}>
                            {renovacionItems.map((item) => (
                              <Chip
                                key={`${row.id}-${item.id || item.numero}-${item.estado}`}
                                label={getRenovacionChipLabel(item)}
                                size="small"
                                className={classes.chipRenovacion}
                                style={{
                                  ...getEstadoRenovacionColor(item.estado),
                                  fontWeight: 600,
                                  maxWidth: 190,
                                }}
                              />
                            ))}
                          </Box>
                        ) : (
                          <Typography
                            variant="body2"
                            style={{
                              color: '#6c757d',
                              fontWeight: 400
                            }}
                          >
                            -
                          </Typography>
                        )}
                      </TableCell>

                      <TableCell align="left">{row.estado}</TableCell>

                      {/* Cronogramas Pendientes */}
                      <TableCell align="left">
                        {cronogramasPendientes[row.id] && cronogramasPendientes[row.id].length > 0 ? (
                          <Box>
                            <Typography variant="caption" style={{ fontWeight: 600, color: '#2e7d32', display: 'block', marginBottom: '4px' }}>
                              {cronogramasPendientes[row.id].length} pendiente{cronogramasPendientes[row.id].length > 1 ? 's' : ''}
                            </Typography>

                            {/* Contenedor de chips con scroll vertical cuando está expandido */}
                            <Box style={{
                              display: 'flex',
                              flexDirection: 'column',
                              gap: '4px',
                              maxWidth: '200px',
                              maxHeight: expandedConvenios[row.id] ? '300px' : 'auto',
                              overflowY: expandedConvenios[row.id] ? 'auto' : 'visible',
                              paddingRight: expandedConvenios[row.id] ? '4px' : '0'
                            }}>
                              {/* Primera fila - 2 cronogramas */}
                              <Box style={{ display: 'flex', gap: '4px', flexWrap: 'nowrap' }}>
                                {cronogramasPendientes[row.id].slice(0, 2).map((cronograma) => (
                                  <Tooltip
                                    key={cronograma.id}
                                    title={`Cronograma #${cronograma.id} - Enviado: ${cronograma.fechaEnvio ? new Date(cronograma.fechaEnvio).toLocaleDateString('es-ES') : 'Sin fecha'}`}
                                    arrow
                                  >
                                    <Chip
                                      label={`#${cronograma.id}`}
                                      size="small"
                                      style={{
                                        backgroundColor: '#e8f5e9',
                                        color: '#2e7d32',
                                        border: '1px solid #4caf50',
                                        fontWeight: 600,
                                        fontSize: '0.65rem',
                                        height: '22px',
                                        cursor: 'default',
                                        minWidth: '60px'
                                      }}
                                    />
                                  </Tooltip>
                                ))}
                              </Box>

                              {/* Segunda fila - 2 cronogramas más (si hay más de 2) */}
                              {cronogramasPendientes[row.id].length > 2 && (
                                <Box style={{ display: 'flex', gap: '4px', flexWrap: 'nowrap' }}>
                                  {cronogramasPendientes[row.id].slice(2, 4).map((cronograma) => (
                                    <Tooltip
                                      key={cronograma.id}
                                      title={`Cronograma #${cronograma.id} - Enviado: ${cronograma.fechaEnvio ? new Date(cronograma.fechaEnvio).toLocaleDateString('es-ES') : 'Sin fecha'}`}
                                      arrow
                                    >
                                      <Chip
                                        label={`#${cronograma.id}`}
                                        size="small"
                                        style={{
                                          backgroundColor: '#e8f5e9',
                                          color: '#2e7d32',
                                          border: '1px solid #4caf50',
                                          fontWeight: 600,
                                          fontSize: '0.65rem',
                                          height: '22px',
                                          cursor: 'default',
                                          minWidth: '60px'
                                        }}
                                      />
                                    </Tooltip>
                                  ))}
                                </Box>
                              )}

                              {/* Filas expandidas (si está expandido y hay más de 4) */}
                              {expandedConvenios[row.id] && cronogramasPendientes[row.id].length > 4 && (
                                <>
                                  {Array.from({ length: Math.ceil((cronogramasPendientes[row.id].length - 4) / 2) }).map((_, rowIndex) => {
                                    const startIdx = 4 + (rowIndex * 2);
                                    const endIdx = startIdx + 2;
                                    return (
                                      <Box key={`row-${rowIndex}`} style={{ display: 'flex', gap: '4px', flexWrap: 'nowrap' }}>
                                        {cronogramasPendientes[row.id].slice(startIdx, endIdx).map((cronograma) => (
                                          <Tooltip
                                            key={cronograma.id}
                                            title={`Cronograma #${cronograma.id} - Enviado: ${cronograma.fechaEnvio ? new Date(cronograma.fechaEnvio).toLocaleDateString('es-ES') : 'Sin fecha'}`}
                                            arrow
                                          >
                                            <Chip
                                              label={`#${cronograma.id}`}
                                              size="small"
                                              style={{
                                                backgroundColor: '#e8f5e9',
                                                color: '#2e7d32',
                                                border: '1px solid #4caf50',
                                                fontWeight: 600,
                                                fontSize: '0.65rem',
                                                height: '22px',
                                                cursor: 'default',
                                                minWidth: '60px'
                                              }}
                                            />
                                          </Tooltip>
                                        ))}
                                      </Box>
                                    );
                                  })}
                                </>
                              )}
                            </Box>

                            {/* Botón Ver más / Ver menos - FUERA del contenedor con scroll */}
                            {cronogramasPendientes[row.id].length > 4 && (
                              <Box style={{ marginTop: '4px' }}>
                                <Button
                                  size="small"
                                  onClick={() => toggleExpandConvenio(row.id)}
                                  style={{
                                    fontSize: '0.65rem',
                                    padding: '2px 8px',
                                    textTransform: 'none',
                                    color: '#2e7d32',
                                    fontWeight: 600,
                                    minHeight: 'auto'
                                  }}
                                >
                                  {expandedConvenios[row.id] ? '▲ Ver menos' : `▼ Ver más (${cronogramasPendientes[row.id].length - 4} más)`}
                                </Button>
                              </Box>
                            )}
                          </Box>
                        ) : (
                          <Typography variant="caption" color="textSecondary" style={{ fontStyle: 'italic' }}>
                            -
                          </Typography>
                        )}
                      </TableCell>

                    </TableRow>
                    );
                  })}
                </TableBody>
                <TableFooter>
                  <TableRow>
                    <TablePagination
                      rowsPerPageOptions={[10, 15, 20]}
                      colSpan={10}
                      count={filteredRows.length}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      SelectProps={{
                        inputProps: { "aria-label": "Registros por página" },
                        native: false,
                      }}
                      labelDisplayedRows={({ from, to, count }) =>
                        `${from}-${to} de ${count}`
                      }
                      labelRowsPerPage="Registros por página"
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                  </TableRow>
                </TableFooter>
              </Table>
              </div>
            </div>

            {/* Menú de Acciones */}
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleMenuClose}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              PaperProps={{
                style: {
                  boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                  borderRadius: '8px',
                  minWidth: '180px',
                },
              }}
            >
              <MenuItem onClick={handleVerDetalles} style={{ padding: '10px 16px' }}>
                <ListItemIcon style={{ minWidth: '36px' }}>
                  <VisibilityIcon fontSize="small" style={{ color: '#007bff' }} />
                </ListItemIcon>
                <ListItemText
                  primary="Ver detalles"
                  primaryTypographyProps={{
                    style: { fontSize: '0.875rem', fontWeight: 500 }
                  }}
                />
              </MenuItem>

              {(hasRole(Roles.ROLE_ADMIN) || hasRole(Roles.ROLE_DNERHS)) && (
                <MenuItem onClick={handleEditarVigencia} style={{ padding: '10px 16px' }}>
                  <ListItemIcon style={{ minWidth: '36px' }}>
                    <EditIcon fontSize="small" style={{ color: '#28a745' }} />
                  </ListItemIcon>
                  <ListItemText
                    primary="Editar vigencia"
                    primaryTypographyProps={{
                      style: { fontSize: '0.875rem', fontWeight: 500 }
                    }}
                  />
                </MenuItem>
              )}
            </Menu>

            {/* Sección de Botones */}
            <div style={{
              padding: '16px 20px',
              background: '#f8f9fa',
              borderTop: '1px solid #dee2e6'
            }}>
              <Grid
                container
                direction="row"
                justifyContent="space-between"
                spacing={1}
                alignItems="center"
              >
                <Grid item>
                  <Button
                    variant="outlined"
                    onClick={() => history.goBack()}
                    style={{
                      borderRadius: 4,
                      textTransform: 'none',
                      fontWeight: 500,
                      borderColor: '#6c757d',
                      color: '#6c757d'
                    }}
                  >
                    ← Atrás
                  </Button>
                </Grid>
                {!hasRole(Roles.ROLE_DNERHS) && (
                  <Grid item>
                    <Link to="/convenios/crear" style={{ textDecoration: 'none' }}>
                      <Button
                        variant="contained"
                        startIcon={<AddIcon />}
                        style={{
                          backgroundColor: '#007bff',
                          color: 'white',
                          borderRadius: 4,
                          textTransform: 'none',
                          fontWeight: 500,
                          '&:hover': {
                            backgroundColor: '#0056b3',
                          }
                        }}
                      >
                        Crear Nuevo Convenio
                      </Button>
                    </Link>
                  </Grid>
                )}
              </Grid>
            </div>
          </Paper>
        </Grid>
      </Grid>

      {/* Modal de Edición de Vigencia */}
      <EditarVigenciaModal
        open={editModalOpen}
        onClose={handleCloseEditModal}
        convenio={selectedConvenio}
        onSave={handleSaveEdit}
      />
    </div>
  );
};

export default List;
